import Footer from '@/components/footer/footer'
import Header from '@/components/header/header'
import referredItem from '@/components/referredItem/referredItem'
import referredCode from '@/components/referredCode/referredCode'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Getter, State, Action } from 'vuex-class'
import SocialSharing from 'vue-social-sharing'
import CashbackInfo from '../../components/cashback/cashbackInfo'

@Component({
  components: {
    Footer,
    Header,
    referredItem,
    referredCode,
    SocialSharing,
    CashbackInfo
  }
})
export default class Indicated extends Vue {
  @Getter getWallet: any
  @Getter getUniversityVariables: any
  @Getter getUniversity: any
  @Getter getUser: any
  @Getter getReferences: any
  @Action action_getReference: any

  couponError = false

  mounted () {
    this.getReferrals()
  }

  get nombreCupon () {
    return this.getUser.reference_code
  }

  get getCashbackEnabled () {
    const percent = this.getUniversityVariables.filter((item) => item.name === 'cashback_enabled')
    return JSON.parse(percent[0].value)
  }

  getReferrals () {
    this.action_getReference()
      .catch((error) => {
        this.couponError = true
      })
  }
  copyCode () {
    const self = this
    navigator.clipboard.writeText(this.getUser.reference_code)
      .then(function () {
        self.$swal({
          imageUrl: '/assets/images/ui/cohete.png',
          imageWidth: 100,
          title: 'Código Copiado',
          timer: 2000,
          showConfirmButton: true
        })
      })
  }

  // _openInterCom() {
  //   let message = 'Hola! :D  ¿quisiera tener mas información acerca de como obtener mi billetera?';
  //   (window as any).Intercom('showNewMessage', message)
  // }

}
